export default "__VITE_ASSET__z040fRN0__"